import { AuxProgressIndicator } from "@blk/aladdin-react-components-es";
import { AuxProgressIndicatorTypeEnum } from "@blk/aladdin-web-components";
import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { useStore } from "react-redux";
import { STATE_INITIALIZING, publishToMessageBus } from "common/ins-message-bus";
import { UxContextComponent } from "plugins/context";
const injectReducerFactory = (store) => (key, reducer, middleware) => {
    if (store.injectedReducers[key] === reducer) {
        return;
    }
    store.injectedReducers[key] = reducer;
    if (middleware) {
        store.addMiddleware(middleware);
    }
    store.replaceReducer(store.createReducer(store.injectedReducers));
};
const getInjectors = (store) => ({
    injectReducer: injectReducerFactory(store)
});
const useInjectReducer = (props) => {
    const store = useStore();
    const [isInjected, setIsInjected] = useState(false);
    useLayoutEffect(() => {
        if (Array.isArray(props)) {
            props.forEach((option) => {
                getInjectors(store).injectReducer(option.key, option.reducer, option.middleware);
                option.subscriptions?.();
            });
        }
        else {
            getInjectors(store).injectReducer(props.key, props.reducer, props.middleware);
            props.subscriptions?.();
        }
        setIsInjected(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return isInjected;
};
const getContext = (options) => {
    if (Array.isArray(options)) {
        return options.reduce((acc, option) => ({ ...acc, ...option.context }), {});
    }
    return options.context ?? {};
};
const useSetInitialState = (props, injected) => {
    const initialStates = useMemo(() => {
        if (Array.isArray(props)) {
            return props.map((option) => option.initialState).filter((o) => Boolean(o));
        }
        if (props.initialState) {
            return [props.initialState];
        }
        return [];
    }, [props]);
    useEffect(() => {
        if (injected) {
            for (const state of initialStates) {
                publishToMessageBus(STATE_INITIALIZING, state);
            }
        }
    }, [initialStates, injected]);
    return initialStates;
};
export const createReducerRegistry = (options) => {
    const Manager = (props) => {
        const isReducerInjected = useInjectReducer(options);
        useSetInitialState(options, isReducerInjected);
        if (!isReducerInjected) {
            return React.createElement(AuxProgressIndicator, { hasLabel: false, isSpinner: true, progress: 25, type: AuxProgressIndicatorTypeEnum.LOADING });
        }
        return React.createElement(UxContextComponent.Provider, { value: getContext(options) }, props.children);
    };
    Manager.displayName = Array.isArray(options) ? options[0]?.name : options?.name;
    return Manager;
};
